export default __webpack_public_path__ + "static/media/icons-cerrar-24-px.ddc857f5.svg";